import { FC } from 'react';
import classNames from 'classnames/bind';

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { customersActions, selectCustomers } from '../../../features';
import { ICustomer } from '../../../model';
import { DropDownList } from '../dropdownlist/DropDownList';

import styles from './CustomerDropdownList.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  className?: string;
  /**
   * Shows the current customer as the selected value. If false, the placeholder is shown,
   * so the current customer can be chosen as well. Defaults to true.
   */
  showCurrent?: boolean;
  /**
   * Called after the customer is selected.
   */
  onSelect?: (customer: ICustomer, previousCustomerId?: string) => void;
}

export const CustomerDropdownList: FC<IProps> = ({ className, showCurrent = true, onSelect }) => {
  const dispatch = useAppDispatch();
  const customers = useAppSelector(selectCustomers);

  const handleChange = (customer: ICustomer | null) => {
    const previousCustomerId = customers.current?.id;
    dispatch(customersActions.setCustomer(customer));

    if (customer) {
      onSelect?.(customer, previousCustomerId);
    }
  };

  return (
    <DropDownList
      data={customers.allCustomers}
      dataItemKey='id'
      textField='name'
      onChange={(e) => handleChange(e.target.value)}
      value={showCurrent ? customers.current : null}
      placeholder='Select Customer'
      className={cx('customersDropdown', className)}
    />
  );
};
